import { GameAudio } from "../audio/GameAudio";
import { GameConfig, visibleDesignHeight } from "../config/GameConfig";
import { Theme } from "./Theme";
import { UIFactory } from "./UIFactory";

export class SettingsOverlay extends Laya.Box {
    private readonly stateLabel: Laya.Label;
    private readonly switchKnob: Laya.Sprite;
    private readonly switchTrack: Laya.Sprite;

    constructor(onClose?: () => void) {
        super();
        this.name = "settings_overlay";
        this.width = GameConfig.DESIGN_WIDTH;
        this.height = visibleDesignHeight();
        this.mouseEnabled = true;
        this.graphics.drawRect(0, 0, this.width, this.height, "#071B2CCC");

        const panel = new Laya.Box();
        panel.width = 610;
        panel.height = 500;
        panel.pivot(305, 250);
        panel.pos(this.width / 2, this.height / 2 - 30);
        UIFactory.roundRect(panel, 0, 12, 610, 488, 30, "#742417", "#4D1A13", 4);
        UIFactory.roundRect(panel, 0, 0, 610, 488, 30, "#FFF0C8", "#E6A74C", 6);
        UIFactory.roundRect(panel, 16, 16, 578, 456, 24, "#FFF8E6", "#D5934B", 2);
        this.addChild(panel);

        const ribbon = UIFactory.titleRibbon("设置", 330);
        ribbon.pos(140, -32);
        panel.addChild(ribbon);

        const row = new Laya.Box();
        row.width = 530;
        row.height = 126;
        row.pos(40, 130);
        row.mouseEnabled = true;
        UIFactory.roundRect(row, 0, 0, 530, 126, 20, "#FFE5AD", "#D68C3C", 3);
        const icon = UIFactory.label("♫", 42, Theme.redDark, 72, 72, true);
        icon.pos(24, 18);
        icon.mouseEnabled = false;
        row.addChild(icon);
        const title = UIFactory.label("背景音乐", 29, Theme.ink, 230, 50, false);
        title.align = "left";
        title.pos(105, 18);
        title.mouseEnabled = false;
        row.addChild(title);
        this.stateLabel = UIFactory.label("", 20, "#9A5A39", 230, 36, false);
        this.stateLabel.align = "left";
        this.stateLabel.pos(105, 70);
        this.stateLabel.mouseEnabled = false;
        row.addChild(this.stateLabel);

        this.switchTrack = new Laya.Sprite();
        this.switchTrack.pos(390, 38);
        row.addChild(this.switchTrack);
        this.switchKnob = new Laya.Sprite();
        this.switchKnob.pos(390, 38);
        row.addChild(this.switchKnob);
        // Keep the overlay as the event caller. Using `row` here makes `this`
        // inside toggleMusic point at the row and prevents the UI from updating.
        row.on(Laya.Event.CLICK, this, this.toggleMusic);
        panel.addChild(row);

        const note = UIFactory.label("关闭后仅停止循环背景音乐\n过关、失败和道具音效仍会保留", 21, "#7D5B47", 500, 76, true);
        note.pos(55, 280);
        note.wordWrap = true;
        panel.addChild(note);

        const close = UIFactory.button("完成", 260, 72, () => {
            Laya.Tween.to(panel, { scaleX: 0.86, scaleY: 0.86, alpha: 0 }, 150, Laya.Ease.quadIn, Laya.Handler.create(this, () => {
                onClose?.();
                this.destroy(true);
            }));
        }, "red", 29);
        close.pos(175, 382);
        panel.addChild(close);

        panel.scale(0.82, 0.82);
        panel.alpha = 0;
        Laya.Tween.to(panel, { scaleX: 1, scaleY: 1, alpha: 1 }, 220, Laya.Ease.backOut);
        this.renderMusicState();
    }

    private toggleMusic(): void {
        GameAudio.setMusicEnabled(!GameAudio.isMusicEnabled());
        this.renderMusicState();
    }

    private renderMusicState(): void {
        const enabled = GameAudio.isMusicEnabled();
        this.stateLabel.text = enabled ? "已开启" : "已关闭";
        this.stateLabel.color = enabled ? "#3F8B31" : "#9A5A39";
        this.switchTrack.graphics.clear();
        this.switchTrack.graphics.drawRoundRect(0, 0, 112, 52, 26, 26, 26, 26, enabled ? "#55BF3A" : "#A98B77", "#FFF0B0", 3);
        this.switchKnob.graphics.clear();
        this.switchKnob.graphics.drawCircle(enabled ? 86 : 26, 26, 20, "#FFF8DC", "#C67A30", 2);
    }
}
